import React from "react";
import Header from "./Header";
import Footer from "./Footer";

const PageShell = ({ children, plain = false }) => {
  return (
    <div className="flex min-h-screen flex-col bg-white font-body">
      <Header />
      <main
        className={
          plain
            ? "flex-1"
            : "flex-1 bg-gradient-to-b from-[#f5f9fd] via-[#f7fbf8] to-white"
        }
      >
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default PageShell;
